module.exports = __webpack_public_path__ + "../resources/images/headshot-robert-74fbabe18205f76ddcddcb0484a83421.png";